import type { PluginDriver } from '../../src/utils/PluginDriver';

export function catchUnfinishedHookActions<T>(
	_pluginDriver: PluginDriver,
	callback: () => Promise<T>
): Promise<T> {
	return callback();
}
